import { render, staticRenderFns } from "./Pagamento.vue?vue&type=template&id=40fea143&scoped=true&"
import script from "./Pagamento.vue?vue&type=script&lang=js&"
export * from "./Pagamento.vue?vue&type=script&lang=js&"
import style0 from "./Pagamento.vue?vue&type=style&index=0&id=40fea143&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fea143",
  null
  
)

export default component.exports